import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PHOTO_ABOUT } from "../data/site";

const CRED = [
  { yr: "2014", t: "DM Gastroenterology, BHU" },
  { yr: "2014–2025", t: "10+ years independent practice in Varanasi" },
  { yr: "Member", t: "Indian Society of Gastroenterology (ISG)" },
  { yr: "Member", t: "Indian National Association for Study of Liver (INASL)" },
  { yr: "Member", t: "Society of GI Endoscopy of India (SGEI)" },
  { yr: "Focus", t: "Advanced Endoscopy, Hepatology, Therapeutic GI" },
];

export default function MeetDoctor({ headingTag: Tag = "h2" }) {
  return (
    <section
      id="about"
      data-testid="meet-doctor-section"
      className="section-pad bg-[#fbfaf7] border-y border-black/10"
    >
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-5">
          <div className="relative">
            <div className="aspect-[4/5] overflow-hidden border border-black/10 bg-white rounded-[6px]">
              <img
                data-testid="meet-doctor-image"
                src={PHOTO_ABOUT}
                alt="Dr. Indresh Dixit — DM Gastroenterologist, Varanasi"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute -bottom-5 -right-5 hidden md:block bg-[#0370AD] text-white px-5 py-4 rounded-[6px]">
              <div className="font-serif-display text-3xl leading-none">10+</div>
              <div className="text-[11px] tracking-[0.18em] uppercase mt-1">
                Years Experience
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="overline">Meet the Doctor</div>
          <Tag className="font-serif-display mt-5 text-4xl sm:text-5xl lg:text-[60px] tracking-tight leading-[1.02]">
            Dr. Indresh Dixit — DM Gastroenterologist in Varanasi.
          </Tag>
          <p className="mt-7 text-black/70 leading-relaxed max-w-2xl text-[16px]">
            A DM Gastroenterology graduate of Banaras Hindu University, Dr.
            Dixit has spent the last decade focused exclusively on digestive,
            liver and endoscopic disease. The practice is small by design — so
            every patient gets unhurried diagnosis, plain-language explanation,
            and a long-term plan, not a prescription pad.
          </p>

          <h3 className="sr-only">Credentials &amp; Memberships</h3>
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-px bg-black/10 border border-black/10 rounded-[6px] overflow-hidden">
            {CRED.map((c, i) => (
              <div
                key={i}
                data-testid={`credential-${i}`}
                className="bg-[#fbfaf7] p-6 flex flex-col gap-2"
              >
                <div className="text-[11px] tracking-[0.2em] uppercase text-[#0370AD] font-semibold">
                  {c.yr}
                </div>
                <div className="text-[15px] font-medium text-black/85">
                  {c.t}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10">
            <Link
              to="/about"
              data-testid="meet-doctor-cta"
              className="group inline-flex items-center gap-2 font-semibold text-[14px] border-b border-black pb-1"
            >
              Read the full profile{" "}
              <ArrowUpRight className="h-4 w-4 arrow" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
